import React from "react";
import { useTranslation } from "react-i18next";
import parseJSON from "date-fns/parseJSON";
import format from "date-fns/format";

import { InfoPlate } from "fe-shared/src/components";

import {
  PaperFormIndicator,
  TransactionStatusPlate,
} from "fe-shared-transactions/src/components";
import { formatTransactionNumber } from "fe-shared-transactions/src/helpers/format";
import { Transaction } from "fe-shared-transactions/src/types";

import styles from "./TransactionStatus.module.scss";

interface Props {
  transaction: Transaction;
}

const TransactionStatus = (props: Props) => {
  const {
    statusCode,
    isPaperForm,
    isAdjustable,
    transactionNumber,
    invalidationDate,
    invalidationReason,
    isVisibleInvalidationReasonParticipant,
  } = props.transaction;

  const { t } = useTranslation();

  const isInvalidationInfo = invalidationReason && invalidationDate;
  const date = parseJSON(invalidationDate || new Date().toJSON());
  const formattedDate = format(date, "dd MMM yyyy");

  return (
    <div className={styles.header}>
      <div className={styles.status}>
        <InfoPlate variant="black" className={styles.statusInfoPlate}>
          {formatTransactionNumber(transactionNumber)}
        </InfoPlate>
        <TransactionStatusPlate
          isAdjustable={isAdjustable}
          statusCode={statusCode}
          className={styles.statusInfoPlate}
        />
        <PaperFormIndicator isPaperForm={isPaperForm} />
      </div>
      {isInvalidationInfo && (
        <div className={styles.invalidationInfo}>
          <span>
            {t("transactions.details.invalidation.stringExternal", {
              date: formattedDate,
            })}
          </span>
          {isVisibleInvalidationReasonParticipant && (
            <span>
              {t("transactions.details.invalidation.reason", {
                reason: invalidationReason,
              })}
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default TransactionStatus;
